import FormattedMessage from 'I18n/components/FormattedMessage';
import { FeatureName } from 'feature-monetization';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { FeatureDisplayChecklistItem } from './FeatureDisplayChecklistItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriorityFeatures = ({
  features
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: features.map((feature, index) => {
      const secondaryMessage = feature.shortName === 'payments' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.priorityFeatures.usOnly"
      }) : null;
      return /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: index > 0 ? '100' : undefined,
        children: /*#__PURE__*/_jsx(FeatureDisplayChecklistItem, {
          tooltipMessage: /*#__PURE__*/_jsx(SanitizedText, {
            body: feature.description,
            formattingOptions: {
              isPlainText: false,
              shouldPreserveNewlines: true,
              shouldOpenLinksInNewTab: true
            }
          }),
          message: /*#__PURE__*/_jsx(FeatureName, {
            featureDisplayName: feature.displayName,
            isBeta: feature.isBeta
          }),
          secondaryMessage: secondaryMessage,
          isAvailable: 'isAvailable' in feature ? feature.isAvailable : undefined
        })
      }, feature.shortName);
    })
  });
};